import Code from 'enum/lang-code.enum';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';

const getIsRTLLanguage = () => {
  const lang = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGECODE);
  const app = document.getElementById('root');
  const isRTL = lang === Code.AR;
  app.style.direction = isRTL ? 'rtl' : 'ltr';
  app.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  return isRTL;
};

export default getIsRTLLanguage;
